import React, { useEffect, useState, useRef } from "react";
import QuizImg from "../../../componenet/quizimg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Get_quiz_data, userquery } from "../../../redux/authslice";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const Quizpage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { QuizzData } = useSelector((state) => state.counter);
  const [show, setShow] = useState(false);
  const [query, setQuery] = useState("");
  const [queryCheck, setQueryCheckset] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setQuery((prevData) => ({
      ...prevData,
      question: id,
    }));
  };

  useEffect(() => {
    let q_id = localStorage.getItem("id");
    if (q_id) {
      dispatch(Get_quiz_data({ id: q_id, dispatch }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (!QuizzData) {
      navigate("/quizgenerator");
    }
  }, [QuizzData, navigate]);

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [showExplanation, setShowExplanation] = useState(false);
  const [hasNavigatedLastQuestion, setHasNavigatedLastQuestion] =
    useState(false);
  // Store cursor positions for each question
  const [cursorPositions, setCursorPositions] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQueryCheckset(!(query?.query?.length > 3));
    setQuery((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onSubmit = () => {
    dispatch(userquery(dispatch, setShow, query));
  };

  const handleAnswerButtonClick = (answer, cursorPos = null) => {
    const currentQuestionId = QuizzData?.data?.[currentQuestionIndex]?.id;

    setUserAnswers((prevUserAnswers) => {
      const updatedAnswers = prevUserAnswers.filter(
        (ans) => ans.Question_id !== currentQuestionId
      );

      if (answer.trim() !== "") {
        updatedAnswers.push({
          quiz_id: localStorage.getItem("id"),
          Question_id: currentQuestionId,
          answer,
        });
      }

      return updatedAnswers;
    });

    // Save cursor position if provided
    if (cursorPos !== null) {
      setCursorPositions((prev) => ({
        ...prev,
        [currentQuestionId]: cursorPos,
      }));
    }
  };

  const handleNextButtonClick = () => {
    setShowExplanation(false);
    const nextQuestionIndex = currentQuestionIndex + 1;
    if (nextQuestionIndex < QuizzData?.data?.length) {
      setCurrentQuestionIndex(nextQuestionIndex);
    } else {
      setShowResults(true);
      setHasNavigatedLastQuestion(true);
    }
  };

  const handlePreviousButtonClick = () => {
    setShowExplanation(false);
    const prevQuestionIndex = currentQuestionIndex - 1;
    if (prevQuestionIndex >= 0) {
      setCurrentQuestionIndex(prevQuestionIndex);
    }
  };

  const handleExplanationButtonClick = () => {
    setShowExplanation(!showExplanation);
  };

  if (!Array.isArray(QuizzData?.data)) {
    return <p>Invalid quiz data</p>;
  }

  const Question = ({
    currentQuestionIndex,
    questionData,
    onAnswerClick,
    autoFoucs,
    cursorPositions,
  }) => {
    const inputRef = useRef(null);
    const [hover, setHover] = useState(false);

    useEffect(() => {
      if (autoFoucs && inputRef.current) {
        inputRef.current.focus();

        // Get the saved cursor position for this question
        const savedCursorPos = cursorPositions[questionData?.id];

        if (savedCursorPos !== undefined) {
          // Restore the saved cursor position
          inputRef.current.setSelectionRange(savedCursorPos, savedCursorPos);
        } else {
          // Otherwise, set cursor to the end
          const length = inputRef.current.value?.length || 0;
          inputRef.current.setSelectionRange(length, length);
        }
      }
    }, [autoFoucs, questionData?.id, cursorPositions]);

    const currentQuestionId = questionData?.id;

    const selectedAnswer =
      userAnswers.find((ans) => ans.Question_id === currentQuestionId)
        ?.answer || "";

    const handleInputChange = (e) => {
      const value = e.target.value;
      // Save cursor position before updating the value
      const cursorPos = e.target.selectionStart;

      // Pass both the answer and cursor position to the parent
      onAnswerClick(value, cursorPos);
    };

    const handleInputClick = (e) => {
      // Update cursor position when user clicks in the input
      const cursorPos = e.target.selectionStart;
      setCursorPositions((prev) => ({
        ...prev,
        [currentQuestionId]: cursorPos,
      }));
    };

    const handleInputKeyUp = (e) => {
      // Update cursor position when user types
      const cursorPos = e.target.selectionStart;
      setCursorPositions((prev) => ({
        ...prev,
        [currentQuestionId]: cursorPos,
      }));
    };

    const renderQuestion = () => {
      switch (questionData?.question_type) {
        case "mcq":
          return (
            <div>
              {questionData?.options?.map((ele, index) => (
                <div key={index}>
                  <input
                    type="checkbox"
                    id={`option-${index}`}
                    name="mcq"
                    value={ele}
                    checked={selectedAnswer === ele}
                    onChange={(e) => onAnswerClick(e.target.value)}
                  />
                  &nbsp;
                  <label htmlFor={`option-${index}`}>{ele}</label>
                </div>
              ))}
            </div>
          );
        case "fill_ups":
          return (
            <input
              style={{
                padding: "5px 5px 60px",
                width: "100%",
                height: "100px",
                boxSizing: "border-box",
                position: "relative",
                border: "1px solid #B9BBC6",
                borderRadius: "10px",
                zIndex: 99,
              }}
              ref={inputRef}
              id="text"
              type="text"
              value={selectedAnswer || ""}
              onChange={handleInputChange}
              onClick={handleInputClick}
              onKeyUp={handleInputKeyUp}
            />
          );
        case "short_answer":
          return (
            <textarea
              style={{
                padding: "5px 5px 60px",
                width: "100%",
                height: "100px",
                boxSizing: "border-box",
                position: "relative",
                border: "1px solid #B9BBC6",
                borderRadius: "10px",
                zIndex: 99,
              }}
              ref={inputRef}
              className="form-control"
              rows="3"
              value={selectedAnswer || ""}
              onChange={handleInputChange}
              onClick={handleInputClick}
              onKeyUp={handleInputKeyUp}
            />
          );
        case "true_false":
          return (
            <div>
              <div>
                <input
                  type="checkbox"
                  id="true"
                  name="true_false"
                  value="True"
                  checked={selectedAnswer === "True"}
                  onChange={(e) => onAnswerClick(e.target.value)}
                />
                &nbsp;
                <label htmlFor="true">True</label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="false"
                  name="true_false"
                  value="False"
                  checked={selectedAnswer === "False"}
                  onChange={(e) => onAnswerClick(e.target.value)}
                />
                &nbsp;
                <label htmlFor="false">False</label>
              </div>
            </div>
          );
        default:
          return null;
      }
    };

    return (
      <>
        <div className="question-left">
          {QuizzData?.data?.map(
            (ele, ind) =>
              currentQuestionIndex === ind && (
                <p key={ind} className="question3">
                  <div className="flag-div d-flex justify-content-end">
                    <i
                      className="fa-solid fa-flag"
                      onClick={() => handleShow(ele?.id)}
                    ></i>
                  </div>
                  Question {ind + 1}
                </p>
              )
          )}
          <p className="question-x text-dark">{questionData?.question}</p>
          <br></br>
        </div>

        <p className="select-text">Submit answer</p>
        {questionData?.question_type !== "fill_ups" &&
        questionData?.question_type !== "short_answer" ? (
          <div className="correct-ans">{renderQuestion()}</div>
        ) : (
          renderQuestion()
        )}
      </>
    );
  };

  return (
    <>
      <section className="foundation-all">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="algebra-foundation">
                <p className="foundation-heading1 text-uppercase">
                  {QuizzData?.quiz_detail &&
                  Object.keys(QuizzData?.quiz_detail).length > 0
                    ? [
                        QuizzData?.quiz_detail.subject
                          ? QuizzData?.quiz_detail.subject
                          : "",
                        QuizzData?.quiz_detail.levelOfStudy
                          ? QuizzData?.quiz_detail.levelOfStudy
                          : "",
                        QuizzData?.quiz_detail.board
                          ? QuizzData?.quiz_detail.board
                          : "",
                        QuizzData?.quiz_detail.topic
                          ? QuizzData?.quiz_detail.topic
                          : "",
                        QuizzData?.quiz_detail.level
                          ? QuizzData?.quiz_detail.level
                          : "",
                      ].join("-")
                    : "Maths-GCSE-AQA-Algebra-Foundation"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section></section>
      <section className="all-dasboard">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="question-box">
                <div className="row">
                  <div className="col-lg-8">
                    <Question
                      currentQuestionIndex={currentQuestionIndex}
                      questionData={QuizzData?.data[currentQuestionIndex]}
                      onAnswerClick={handleAnswerButtonClick}
                      selectedAnswer={userAnswers[currentQuestionIndex]}
                      autoFoucs={true}
                      cursorPositions={cursorPositions}
                    />
                    <div className="foundation-all-button">
                      {!showResults && (
                        <>
                          <button
                            className="btn previous-btn-primary"
                            onClick={handlePreviousButtonClick}
                            disabled={currentQuestionIndex === 0}
                          >
                            Previous
                          </button>
                          <button
                            className="btn next-btn-primary"
                            onClick={handleNextButtonClick}
                            disabled={
                              !userAnswers.some(
                                (ans) =>
                                  ans.Question_id ===
                                    QuizzData?.data[currentQuestionIndex]?.id &&
                                  ans.answer.trim() !== ""
                              )
                            }
                          >
                            Next
                          </button>
                        </>
                      )}
                    </div>
                    {showExplanation && (
                      <div className="question-left mt-5">
                        <p>
                          <strong>Explanation:</strong>{" "}
                          {QuizzData?.data[currentQuestionIndex].explanation}
                        </p>
                      </div>
                    )}
                  </div>
                  <QuizImg
                    QuizzData={QuizzData?.data}
                    currentQuestionIndex={currentQuestionIndex}
                    userAnswers={userAnswers}
                    hasNavigatedLastQuestion={hasNavigatedLastQuestion}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fs-6">
            Feeback (Related to Question/Answer)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-floating">
            <textarea
              className="form-control"
              name="query"
              onChange={handleChange}
              placeholder="Leave a feedback here"
              id="floatingTextarea"
              required
              style={{ height: "100px", paddingTop: "40px" }}
            ></textarea>
            <label htmlFor="floatingTextarea" className="mb-3">
              Please leave a query here
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" disabled={queryCheck} onClick={onSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Quizpage;
